export default "__VITE_ASSET__BOZrS$1G__"